import Constants from '@/Constants';
import { ContentMetadata } from '@/models/ContentMetadata';
import { EntityType } from '@/models/EntityTypes';
import Item from '@/models/Item';
import { contentService } from '@/services/ContentService';
import { ApplicationState } from '@/store';
import React, { useState } from 'react';
import { Spinner } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import FavoriteSection from '../FavoriteSection';
import './style.scss';

interface Props {
    content: Item;
    finished: boolean;
    editionMode?: boolean;
    editionConfig?: {
        title: string;
        handle: () => void;
        disable?: boolean;
        hasVisibilityDate?: boolean;
    };
}

const ContentCard: React.FC<Props> = (props: Props) => {
    const { strings } = useSelector((state: ApplicationState) => ({ strings: state.locale.data }));

    const { content, finished, editionConfig, editionMode } = props;

    const [showBtnSpinner, setShowBtnSpinner] = useState<boolean>(false);

    const metadata: ContentMetadata = contentService.getContentMetadata(content);

    const authorNameValidation = () => {
        return content.author ? content.author : '-';
    };

    const ratingValidation = () => {
        return content.rating ? content.rating.toFixed(1) : '-';
    };

    return (
        <div className="main">
            <div className="card-item">
                <div className="card-item__body">
                    <div className="card-item__label">{metadata.typeName}</div>
                    <h3 className="card-item__title" title={content.name}>
                        {content.name}
                    </h3>
                    <p className="card-item__text" title={content.description}>
                        {content.description}
                    </p>
                    <div className="card-item__author">{authorNameValidation()}</div>
                </div>
                <div className="card-item__thumb">
                    <img alt="" className="card-item__thumb__img" src={content.mainImage} />

                    {finished && (
                        <div className="card-item__conclusion-check concluded">
                            <i className="material-icons">{Constants.icons.CHECK}</i>
                        </div>
                    )}
                </div>
                <div className="card-item__footer">
                    <div className="card-item__duration">{`${content.workload} ${strings.MINUTES}`}</div>
                    <div className="card-item__rating">
                        <i className="material-icons">grade</i>
                        <span>{ratingValidation()}</span>
                    </div>
                    {editionConfig && editionMode && !editionConfig.hasVisibilityDate && (
                        <button
                            className="card-item__button-action"
                            disabled={editionConfig.disable}
                            onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                setShowBtnSpinner(true);
                                editionConfig.handle();
                            }}
                            type="button"
                        >
                            {!showBtnSpinner && editionConfig.title === strings.REMOVE && (
                                <>
                                    <i className="material-icons-outlined">{Constants.icons.DELETE}</i>
                                    <span>{editionConfig.title}</span>
                                </>
                            )}
                            {!showBtnSpinner && editionConfig.title === strings.ADD && <span>{editionConfig.title}</span>}
                            {showBtnSpinner && <Spinner animation="border" size="sm" />}
                        </button>
                    )}

                    {!editionMode && (
                        <FavoriteSection
                            buttonMode
                            customActiveClass="active"
                            customClass={`card-item__like`}
                            entityId={content.id as number}
                            entityName={content.name}
                            entityType={EntityType.CONTENT}
                            moduleId={content.moduleId as number}
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

export default ContentCard;
